module.exports = __webpack_public_path__ + "static/media/check.80646591.svg";